import { render } from "./PlanConsolidacion.vue?vue&type=template&id=2c834a5c&scoped=true"
import script from "./PlanConsolidacion.vue?vue&type=script&lang=js"
export * from "./PlanConsolidacion.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./PlanConsolidacion.vue?vue&type=style&index=1&id=2c834a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c834a5c"]])

export default __exports__